/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/common/ViewFinderConfiguration.yaml
import { EdgeInsets } from '../../ui_v2/common/Common';
import { AspectRatio } from '../../utils/geometry/Geometry';
import { PartiallyConstructible } from '../../utils/utils';
/** @internal */
export var BaseViewFinderConfiguration;
(function (BaseViewFinderConfiguration) {
    /** @internal */
    function From(source) {
        const _type = source['_type'];
        switch (_type) {
            case 'ViewFinderConfiguration':
                return new ViewFinderConfiguration(source);
            case 'PermanentViewFinderConfiguration':
                return new PermanentViewFinderConfiguration(source);
            default:
                throw `Unknown child class name: ${_type}`;
        }
    }
    BaseViewFinderConfiguration.From = From;
})(BaseViewFinderConfiguration || (BaseViewFinderConfiguration = {}));
/**
Configuration of the scanning interface’s viewfinder, allowing it to be shown or hidden as guidance to the user.
*/
export class ViewFinderConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<ViewFinderConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'ViewFinderConfiguration';
        /**
          The visual appearance of the viewfinder.
          */
        this.style = new FinderCorneredStyle({
            strokeColor: '?sbColorSurface',
            strokeWidth: 2.0,
            cornerRadius: 10.0,
        });
        /**
          The color of the viewfinder overlay.
          
          Default is "?sbColorSurfaceLow"
          */
        this.overlayColor = '?sbColorSurfaceLow';
        /**
          The viewfinder's aspect ratio.
          */
        this.aspectRatio = new AspectRatio({ width: 1.0, height: 1.0 });
        /**
          The minimum insets of the viewfinder.
          */
        this.minimumInsets = new EdgeInsets({ top: 16.0, left: 16.0, bottom: 16.0, right: 16.0 });
        /**
          The preferred height of the viewfinder.
          
          Default is -1.0
          */
        this.preferredHeight = -1.0;
        /**
          Whether the viewfinder is visible.
          
          Default is true
          */
        this.visible = true;
        if (source.style !== undefined) {
            this.style = FinderStyle.From(source.style);
        }
        if (source.overlayColor !== undefined) {
            this.overlayColor = source.overlayColor;
        }
        if (source.aspectRatio !== undefined) {
            this.aspectRatio = new AspectRatio(source.aspectRatio);
        }
        if (source.minimumInsets !== undefined) {
            this.minimumInsets = new EdgeInsets(source.minimumInsets);
        }
        if (source.preferredHeight !== undefined) {
            this.preferredHeight = source.preferredHeight;
        }
        if (source.visible !== undefined) {
            this.visible = source.visible;
        }
    }
}
/**
Configuration of the scanning interface’s viewfinder, which is always visible to guide the user.
*/
export class PermanentViewFinderConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<PermanentViewFinderConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'PermanentViewFinderConfiguration';
        /**
          The visual appearance of the viewfinder.
          */
        this.style = new FinderCorneredStyle({
            strokeColor: '?sbColorSurface',
            strokeWidth: 2.0,
            cornerRadius: 10.0,
        });
        /**
          The color of the viewfinder overlay.
          
          Default is "?sbColorSurfaceLow"
          */
        this.overlayColor = '?sbColorSurfaceLow';
        /**
          The viewfinder's aspect ratio.
          */
        this.aspectRatio = new AspectRatio({ width: 1.0, height: 1.0 });
        /**
          The minimum insets of the viewfinder.
          */
        this.minimumInsets = new EdgeInsets({ top: 16.0, left: 16.0, bottom: 16.0, right: 16.0 });
        /**
          The preferred height of the viewfinder.
          
          Default is -1.0
          */
        this.preferredHeight = -1.0;
        if (source.style !== undefined) {
            this.style = FinderStyle.From(source.style);
        }
        if (source.overlayColor !== undefined) {
            this.overlayColor = source.overlayColor;
        }
        if (source.aspectRatio !== undefined) {
            this.aspectRatio = new AspectRatio(source.aspectRatio);
        }
        if (source.minimumInsets !== undefined) {
            this.minimumInsets = new EdgeInsets(source.minimumInsets);
        }
        if (source.preferredHeight !== undefined) {
            this.preferredHeight = source.preferredHeight;
        }
    }
}
/** @internal */
export var FinderStyle;
(function (FinderStyle) {
    /** @internal */
    function From(source) {
        const _type = source['_type'];
        switch (_type) {
            case 'FinderCorneredStyle':
                return new FinderCorneredStyle(source);
            case 'FinderStrokedStyle':
                return new FinderStrokedStyle(source);
            default:
                throw `Unknown child class name: ${_type}`;
        }
    }
    FinderStyle.From = From;
})(FinderStyle || (FinderStyle = {}));
/**
A variant of the viewfinder displaying only the four corners of the scanning area.
*/
export class FinderCorneredStyle extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<FinderCorneredStyle>`} */
    constructor(source = {}) {
        super();
        this._type = 'FinderCorneredStyle';
        /**
          The color of the viewfinder corner's outlines.
          
          Default is "#FFFFFFFF"
          */
        this.strokeColor = '#FFFFFFFF';
        /**
          The width of the viewfinder corner's outlines.
          
          Default is 3.0
          */
        this.strokeWidth = 3.0;
        /**
          The radius of the viewfinder's corners.
          
          Default is 10.0
          */
        this.cornerRadius = 10.0;
        if (source.strokeColor !== undefined) {
            this.strokeColor = source.strokeColor;
        }
        if (source.strokeWidth !== undefined) {
            this.strokeWidth = source.strokeWidth;
        }
        if (source.cornerRadius !== undefined) {
            this.cornerRadius = source.cornerRadius;
        }
    }
}
/**
A variant of the viewfinder displaying a full outline of the scanning area.
*/
export class FinderStrokedStyle extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<FinderStrokedStyle>`} */
    constructor(source = {}) {
        super();
        this._type = 'FinderStrokedStyle';
        /**
          The color of the viewfinder corner's outlines.
          
          Default is "#FFFFFFFF"
          */
        this.strokeColor = '#FFFFFFFF';
        /**
          The width of the viewfinder corner's outlines.
          
          Default is 3.0
          */
        this.strokeWidth = 3.0;
        /**
          The radius of the viewfinder's corners.
          
          Default is 10.0
          */
        this.cornerRadius = 10.0;
        if (source.strokeColor !== undefined) {
            this.strokeColor = source.strokeColor;
        }
        if (source.strokeWidth !== undefined) {
            this.strokeWidth = source.strokeWidth;
        }
        if (source.cornerRadius !== undefined) {
            this.cornerRadius = source.cornerRadius;
        }
    }
}
//# sourceMappingURL=ViewFinderConfiguration.js.map